<template>
  <nav
    class="navbar-custom no-print"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <a class="navbar-logo" href="https://everestportal.vercel.app">
        <img src="@/assets/everestAsset1.png" width="100" height="48" />
      </a>
    </div>

    <div class="navbar-content">
      <div class="navbar-end">
        <div class="navbar-user-info">
          <span class="user-greeting">
            Zdravo, <strong>{{ name }}</strong>
          </span>
          <span class="version-badge">v1.4.2</span>
          <button class="logout-button" @click="logoutClick">Log out</button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",

  data() {
    return {
      name: null,
    };
  },

  mounted() {
    this.name =
      this.$store.state.auth.user.firstName +
      " " +
      this.$store.state.auth.user.lastName;
  },

  methods: {
    logoutClick() {
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.navbar-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 24px;
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.navbar-brand {
  display: flex;
  align-items: center;
}

.navbar-logo {
  display: flex;
  align-items: center;
}

.navbar-logo img {
  filter: brightness(1.1);
}

.navbar-content {
  display: flex;
  align-items: center;
}

.navbar-user-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-greeting {
  color: #e2e8f0;
  font-size: 14px;
}

.user-greeting strong {
  color: white;
}

.version-badge {
  background: rgba(255, 255, 255, 0.1);
  color: #94a3b8;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
  font-weight: 500;
}

.logout-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);
}

.logout-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.logout-button:active {
  transform: translateY(0);
}
</style>
